import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-core',
  templateUrl: './icon-core.component.html',
  styleUrls: ['./icon-core.component.scss']
})
export class IconCoreComponent implements OnInit {
    @Input() inline = true;
    @Input() icon = "edit";

    constructor() { }

    ngOnInit(): void {
    }

}
